import React,{useEffect,useState} from 'react';
import {appGetUrlPath,getWaUrlPath} from '../function_lib/common_lib';
import Comp_Video_Player from './comp_video_player';

export const Control_MediaStorageViewer=(props)=>{
  let appUrl=appGetUrlPath();
  const [stGetFilePath, stSetFilePath] = useState("");
  if(window.memc_system){
    appUrl="http://localhost:8080/pdfviewer_v1?"+new Date()+"_"+Math.random().toString();
  }
  
  useEffect(()=>{
    if(window.memc_system){
      //alert(JSON.stringify(props.pData));
     if(typeof props.pData.proItem!=="undefined"){
      if(props.pData?.proItem?.med_file_data){
        let medDataPdf=JSON.parse(props.pData?.proItem?.med_file_data);
        //alert(medDataPdf.med_file_data);
        //appUrl="data:application/pdf;base64,"+medDataPdf.file_enc;
        //alert("without base64 now");
        window.memc_system.setFilePathPdf(medDataPdf.file_enc);
        //alert(props.pData.proItem.id);
        appUrl="http://localhost:8080/pdfviewer_v1?pm="+props.pData.proItem.id;
        stSetFilePath(props.pData.proItem.id);
      }
     }

     
    }

  },[props.pData.proItem,stGetFilePath]);
  if(window.memc_system){
    if(typeof props.pData.proItem!=="undefined"){
      //alert(JSON.stringify(props.pData.proItem));
  //window.memc_system.setFilePathPdf(file_data);
    //alert(JSON.stringify(props.pData?.proItem?.med_file_data));
    if(props.pData?.proItem?.med_file_data){
      let medDataPdf=JSON.parse(props.pData?.proItem?.med_file_data);
      //alert(medDataPdf.med_file_data);
      //appUrl="data:application/pdf;base64,"+medDataPdf.file_enc;
      //alert("without base64 now");
      window.memc_system.setFilePathPdf(medDataPdf.file_enc)
    }
    }
  

    
    

    //alert(appUrl);
    return(<>
    {typeof props.pData?.proItem?.hrfPdf==="undefined" && props.pData?.proItem?.file_path!=="" && stGetFilePath!==""?
<embed allowfullscreen="true" id="samp_comp_pa" width="100%" height="500px" 
                                    src={appUrl}>

                                    </embed>:''}
    </>)
  }
  else{

  
 return(<>
 {typeof props.pData.hrfPdf==="undefined"?<>    
                                    {(typeof props.pData.proItem!=="undefined") && (props.pData.proItem.file_path!=="") ?
                                    <embed id="samp_comp_pa" width="100%" height="500px" 
                                    src={appUrl+"controller/test_reader.php?pm=demReadBookMUI&rf="+btoa(props.pData.proItem.id)+"&rd_index="+props.pData.proItem.product_code} toolbar="0"></embed>
                                    :<div>No file Uploaded</div>
                                    }</>:<></>}

                                    {typeof props.pData.hrfPdf!=="undefined" && props.pData.hrfPdf!==""?<embed id="samp_comp_pa" width="100%" height="500px" 
                                    src={props.pData.hrfPdf} toolbar="0"></embed>:''
                                    }
 </>)
  }
}
export const Comp_View_Pdf=(props)=>{
  let appUrl=appGetUrlPath();
  
     useEffect(()=>{
      //alert(props.hrfPdf)
     },[props.proItem])
     let appUrlFile=getWaUrlPath();
    //alert(JSON.stringify(props));
        return(<div className="modal fade bd-example-modal-xl"  id="divPdfView" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xxl" role="document">
          <div className="modal-content">
          <div className="modal-header bg-primary">
              <h5 className="modal-title text-white" id="exampleModalLabel">
                {(typeof props.proItem!=="undefined" && typeof props.proItem.category_name!=="undefined")?"("+props.proItem.main_category+") "+props.proItem.category_name:''}
                
                </h5>
              <button type="button" className="close text-white" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="text-white">&times;</span>
              </button>
            </div>
            <form id="frmPdfView" name="frmPdfView">
           
            <div className="modal-body">
            <div className="row">
              <div className='col-md-12'>
              {typeof props.proItem!=="undefined" && props.proItem["file_path_2"]!==""?
                <div class="accordion" id="fullWidthAccordion">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      Click to Watch Video
                    </button>
                  </h2>
                  <div id="collapseOne" class="accordion-collapse collapse " aria-labelledby="headingOne" data-bs-parent="#fullWidthAccordion">
                    <div class="accordion-body">
                    <Comp_Video_Player video_url={appUrlFile+props.proItem["file_path_2"]}/>
                    </div>
                  </div>
                </div>
            
              </div>
            :''}
              </div>
                      {/* <!-- left column --> */}
                      <div className="col-md-12">
                          <div className="card card-danger">
                                   <div className="card-body">
                                    {/* place component here */}
                                    {typeof props.hrfPdf==="undefined"?
                                    <Control_MediaStorageViewer pData={props}/>:''
                                  }
                                    
                                   
                                    
                                      <div className="col-md-6 respSSL"></div>
                                      <div id="testing2dd2222"></div>
                                  </div>
                              
                          </div>
                      </div>
                  </div>
            </div>
            <div className="modal-footer">
              {/* <p>Once you have completed the reading , kindly answer the questions</p> */}
            
           {typeof props.isSemester!=="undefined" && 0!==0?<button type="button" data-bs-toggle="modal" data-bs-target="#divTestYourKnow" data-toggle="modal" data-target="#divTestYourKnow" className="btn btn-primary">Test your knowledge</button>:''}
            <div id="getReponse" style={{color:"red"}}></div>
             
            </div>
            </form>
          </div>
          </div>
          </div>
      );
    
}
export default Comp_View_Pdf;
